import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Field } from 'redux-form'
import Svg from 'components/util/Svg'
import './react-datetime.global.css'
import styles from './_dateTimeField.css'
import DateTime from 'react-datetime'
import FieldLabel from '../FieldLabel'
import FieldError from '../FieldError'
import fieldProps from '../fieldProps'
import classnames from 'classnames'

DateTime.prototype.componentWillReceiveProps = function (nextProps) {
  if (this.props.open !== nextProps.open) {
    this.setState({ open: nextProps.open })
  }
}

export class DateTimeField extends Component {

  static propTypes = {
    bold: PropTypes.bool,
    date: PropTypes.bool,
    time: PropTypes.bool,
    error: PropTypes.node,
    label: PropTypes.node,
    required: PropTypes.bool,
    placeholder: PropTypes.node,
    timeFormat: PropTypes.bool,
    dateFormat: PropTypes.bool,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.bool,
    }),
    input: PropTypes.shape({
      onChange: PropTypes.func,
    }),
  };

  static defaultProps = {
    placeholder: '',
    timeFormat: true,
  };

  state = {
    open: false,
  }

  handleChange = (datetime) => {
    // DateTimeField will only ever save a valid moment object
    // or null if the string cannot be parsed into a date
    const newValue = typeof datetime === 'string' ? null : datetime
    this.props.input.onChange(newValue)
  }

  handleFocus = () => {
    this.setState({ open: true })
  }

  handleBlur = () => {
    this.setState({ open: false })
  }

  handleToggleCalendar = (evt) => {
    evt.stopPropagation()
    evt.nativeEvent.stopPropagation()
    if (!this.state.open) {
      this._datetime.openCalendar()
    } else {
      this._datetime.closeCalendar()
    }
  }

  render () {
    const {
      labelComponent,
      errorComponent,
      required,
      timeFormat,
      dateFormat,
      placeholder,
      bold,
      input,
      meta: {
        touched,
        error,
      },
    } = this.props

    const inputProps = {
      placeholder,
      id: name,
    }

    const showError = Boolean(touched && error)

    const icon = timeFormat === false ? 'calendar'
      : dateFormat === false ? 'clock' : 'calendar_time'

    return (
      <div className={styles.container}>
        <label htmlFor={name}>

          <FieldLabel
            labelComponent={labelComponent}
            required={required}
            bold={bold}
          />

          <DateTime
            defaultValue={input.value}
            placeholder={placeholder}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onChange={this.handleChange}
            timeFormat={timeFormat}
            dateFormat={dateFormat}
            ref={(node) => this._datetime = node} // eslint-disable-line no-return-assign
            inputProps={inputProps}
          />

          <FieldError
            errorComponent={errorComponent}
            showError={showError}
            errorMessage={error}
          />

        </label>

        <div className={classnames(styles.toggleButtons, {
          [styles.withLabel]: !!labelComponent,
        })}>
          <div
            className={classnames(styles.iconContainer, {
              [styles.hidden]: !this.state.open,
            })}
            onClick={this.handleToggleCalendar}
          >
            <Svg className={styles.closeIcon} name='x' />
          </div>
          <div
            className={classnames(styles.iconContainer, {
              [styles.hidden]: this.state.open,
            })}
            onClick={this.handleToggleCalendar}
          >
            <Svg className={styles.calendarIcon} name={icon} />
          </div>
        </div>

      </div>
    )
  }

}

DateTimeField.propTypes = fieldProps

export const renderField = (field) => (
  <DateTimeField {...field} />
)

export const FieldWrapper = (props) => (
  <Field {...props} component={renderField} />
)

export default FieldWrapper
